/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box } from "@mui/material";
import clsx from "clsx";
import SalesCard from "./cards/SalesDone";
import ActiveChats from "./cards/ActiveChats";
import ClosedChats from "./cards/ClosedChats";
import TotalChats from "./cards/TotalChats";
import useStyles from "./Styles";

const FigureCards: React.FC = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.rootContainer}>
      <Box className={clsx(classes.flexItems)}>
        <SalesCard />
      </Box>
      <Box className={clsx(classes.flexItems)}>
        <ActiveChats />
      </Box>
      <Box className={clsx(classes.flexItems)}>
        <ClosedChats />
      </Box>
      <Box className={clsx(classes.flexItems)}>
        <TotalChats />
      </Box>
    </Box>
  );
};

export default FigureCards;
